import { api } from 'common';

import { ConditionalFormFields } from './FormFields';
import { ConditionalNodeOutputContent } from './OutputContent';
import { getNewCondition } from './constants';
import { conditionalBlockDocumentationMarkdown } from './documentation';
import { getNodeOutputHandle } from './getNodeOutputHandle';
import { type BlockConfigProps } from '../../types';

export const conditionalConfig: BlockConfigProps<api.FlowDefinition.Conditional.ConditionalBlockConfig> =
  {
    nodeHandles: (config) => {
      return [
        { type: 'target' },
        ...config.conditions.map(getNodeOutputHandle),
        {
          type: 'source',
          id: api.FlowDefinition.Conditional.CONDITIONAL_ELSE_CONDITION_ID,
          handleName: 'Else',
        },
      ];
    },
    defaultLabelPrefix: 'multiConditional',
    defaultConfig: {
      conditionalType: api.FlowDefinition.Conditional.ConditionalType.MatchFirst,
      conditions: [getNewCondition()],
    },
    configFields: {
      schema: api.FlowDefinition.Conditional.conditionalBlockConfigSchema,
      FormFields: ConditionalFormFields,
    },
    documentationMarkdown: conditionalBlockDocumentationMarkdown,
    OutputContentComponent: ConditionalNodeOutputContent,
  };
